(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvon-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orvon-comparison')) {
    customElements.define('orvon-comparison', class OrvonComparison extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.orvon-transform__range');
        this.hotspot = this.querySelector('.orvon-transform__hotspot');
        this.stage = this.querySelector('.orvon-transform__stage');
        if (!this.range) return;

        this.update = () => {
          const position = Number(this.range.value);
          this.style.setProperty('--comparison-position', `${position}%`);
          this.range.setAttribute('aria-valuetext', `${position} percent before, ${100 - position} percent after`);

          if (this.hotspot) {
            const hotspotPosition = Number(this.hotspot.dataset.hotspotX);
            this.hotspot.hidden = position >= hotspotPosition - 1;
          }
        };

        this.range.addEventListener('input', this.update);
        this.update();

        /* Tab 2026-10-22: drag anywhere on the photo with pointer events instead of the invisible
           full-size range input. On phones the range only reacted when the hidden thumb was hit and
           it swallowed vertical swipes. The stage has touch-action: pan-y, so vertical swipes scroll
           the page and a sideways swipe moves the divider on the first touch. The range stays for
           keyboard users. */
        if (!this.stage || !window.PointerEvent || this.dataset.pointerReady) return;
        this.dataset.pointerReady = 'true';
        this.classList.add('orvon-transform--pointer');
        this.drag = null;

        const setFromX = (clientX) => {
          const rect = this.stage.getBoundingClientRect();
          if (!rect.width) return;
          const position = Math.max(0, Math.min(100, Math.round(((clientX - rect.left) / rect.width) * 100)));
          if (String(position) !== this.range.value) {
            this.range.value = String(position);
            this.update();
          }
        };

        this.stage.addEventListener('pointerdown', (event) => {
          if (event.button > 0 || event.target.closest('.orvon-transform__hotspot')) return;
          const isMouse = event.pointerType === 'mouse';
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, active: isMouse };
          if (isMouse) {
            event.preventDefault();
            try { this.stage.setPointerCapture(event.pointerId); } catch (e) {}
            setFromX(event.clientX);
          }
        });

        this.stage.addEventListener('pointermove', (event) => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          if (!drag.active) {
            const dx = Math.abs(event.clientX - drag.x);
            const dy = Math.abs(event.clientY - drag.y);
            if (dx < 6 && dy < 6) return;
            if (dy > dx) { this.drag = null; return; }
            drag.active = true;
            try { this.stage.setPointerCapture(event.pointerId); } catch (e) {}
          }
          setFromX(event.clientX);
        });

        const end = (event) => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          if (event.type === 'pointerup' && !drag.active) setFromX(event.clientX);
          this.drag = null;
        };
        this.stage.addEventListener('pointerup', end);
        this.stage.addEventListener('pointercancel', end);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
